var React = require('react');

function Mail (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Icon_zocial-email","data-name":"Icon zocial-email","d":"M.072,43.416V7.892q0-.062.185-1.172L21.164,24.605.319,44.649a5.227,5.227,0,0,1-.247-1.233ZM2.847,4.253A2.658,2.658,0,0,1,3.9,4.068H60.2a3.492,3.492,0,0,1,1.11.185L40.345,22.2l-2.775,2.22-5.489,4.5-5.489-4.5L23.816,22.2Zm.062,42.8L23.94,26.887l8.141,6.6,8.141-6.6L61.252,47.054a2.961,2.961,0,0,1-1.048.185H3.9a2.793,2.793,0,0,1-.987-.185ZM43,24.605,63.842,6.72a3.681,3.681,0,0,1,.185,1.172V43.416a4.727,4.727,0,0,1-.185,1.233Z","transform":"translate(-0.072 -4.068)","fill":"#fff"}));
}

Mail.defaultProps = {"id":"email_icon","width":"63.955","height":"43.171","viewBox":"0 0 63.955 43.171"};

module.exports = Mail;

Mail.default = Mail;
